import React, { useState, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const SessionInfo = ({ sessionData, duration }) => {
  const [formattedDuration, setFormattedDuration] = useState('00:00');

  useEffect(() => {
    const minutes = Math.floor(duration / 60);
    const seconds = duration % 60;
    setFormattedDuration(
      `${String(minutes)?.padStart(2, '0')}:${String(seconds)?.padStart(2, '0')}`
    );
  }, [duration]);

  return (
    <div className="flex items-center justify-between px-6 py-4 bg-card border-b border-border">
      <div className="flex items-center gap-4">
        <Image
          src={sessionData?.participantAvatar}
          alt={sessionData?.participantAvatarAlt}
          className="w-12 h-12 rounded-full object-cover"
        />
        <div>
          <h2 className="text-lg font-semibold text-foreground">
            {sessionData?.participantName}
          </h2>
          <p className="text-sm text-muted-foreground">
            {sessionData?.participantRole}
          </p>
        </div>
      </div>
      <div className="flex items-center gap-6">
        {/* Session Timer */}
        <div className="flex items-center gap-2">
          <Icon name="Clock" size={20} className="text-muted-foreground" />
          <span className="text-lg font-mono font-medium text-foreground">
            {formattedDuration}
          </span>
        </div>

        {/* Recording Indicator */}
        {sessionData?.isRecording && (
          <div className="flex items-center gap-2 px-3 py-1.5 bg-error/10 rounded-full">
            <div className="w-2 h-2 rounded-full bg-error animate-pulse" />
            <span className="text-sm font-medium text-error">Recording</span>
          </div>
        )}

        {/* Privacy Indicator */}
        <div className="flex items-center gap-2 px-3 py-1.5 bg-success/10 rounded-full">
          <Icon name="Lock" size={16} className="text-success" />
          <span className="text-sm font-medium text-success">Encrypted</span>
        </div>
      </div>
    </div>
  );
};

export default SessionInfo;